import styled from "styled-components";
import {navItemStyle} from "./Navbar.styled";

const StyledServicesDropdown = styled.div`
  position: relative;
  display: flex;

  .servicesToggle {
    ${navItemStyle}
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
  }

  .servicesToggle::after {
    left: 0.5em;
  }

  .servicesToggle h1 {
    white-space: nowrap;
  }

  .servicesToggle span {
    font-size: 0.6em;
  }

  .servicesMenu {
    display: ${({$open}) => ($open ? "flex" : "none")};
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 100%;
    padding: 0.5em 0;
    background-color: white;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    white-space: nowrap;
    z-index: 3;
  }

  .servicesMenu a {
    margin: 0;
    padding: 0 1.5em;
    line-height: normal;
    text-align: left;
  }

  .servicesMenu a::after {
    left: 1.5em;
    bottom: 0.4em;
    width: calc(100% - 3em);
  }

  .servicesMenu p {
    margin: 0.6em 0;
    font-weight: bold;
  }
`;

export default StyledServicesDropdown;
